export const handleUserFlow = function({user_flow, current_user_id, need_handle} = {}) {
    const arr = []
   const current_user_flow_node = (user_flow || {}).current_user_flow_node
    if (!need_handle || !current_user_flow_node) {
        return null
    }
   if (current_user_flow_node.is_reject) {
        arr.push({
            color: 'error',
            text: '驳回'
        })
   }
   if (current_user_flow_node.user_flow_node_users) {
    current_user_flow_node.user_flow_node_users.forEach(node => {
            if (node.customer_id !== current_user_id) {
                return 
            }
            if (node.is_invite) {
                arr.push({
                    color: 'success',
                    text: '邀请'
                })
            }
            if (node.transferers) {
                arr.push({
                    color: 'primary',
                    text: '转移'
                })
            }
        })
   }

    return arr.length ? arr : undefined
}   